function StatusPill({ label, tone }) {
  return <span className={`pill status ${tone || ""}`}>{label}</span>;
}

export default StatusPill;
